<div class="form-group">

  <!-- <div class="custom-input-reveal">
  <ng-container *ngFor="let question of childrenQuestions; let i = index;">
    <div class="custom-input-reveal__item">
      <input type="radio" (click)="checkRadio(question)" [checked]="isChecked(question)" name="radio-pill-example[]" id="reveal-id-{{question?.cent_aq_question_id}}" class="custom-input-reveal__input">
      <label class="custom-input-reveal__control custom-input-reveal__control--radio" for="reveal-id-{{question?.cent_aq_question_id}}">
        <span class="custom-input-reveal__indi"></span>
        <span class="custom-input-reveal__label">{{question?.question_prompt}}</span>
      </label>
      <div *ngIf="showTextbox(question)" class="custom-input-reveal__expander">
        <div class="custom-input-reveal__expander-inner">
          <input type="text" [value]="question?.answer" placeholder="" (blur)="setAnswer(question,$event)" class="form-control">
        </div>
      </div>
    </div>
    <div  *ngIf="i === 2 && question?.itk" class="custom-input-reveal__note">
      <svg class="icon">
        <use xlink:href="#info-small"></use>
      </svg>
      <p>{{question?.itk}}</p>
    </div>
  </ng-container>

</div> -->

<!-- TODO: We need to add a label field
<label class="form-group__label">Label</label>
-->

@for (question of childrenQuestions; track question; let i = $index) {
  <label class="tile tile--reveal">
    <input type="radio" (click)="checkRadio(question)" [checked]="isChecked(question)" name="radio-pill-example[]" id="reveal-id-{{question?.cent_aq_question_id}}">
    <div class="tile__inner">
      <div class="tile__main">
        <div class="tile__content">
          <div class="tile__indi"><span></span></div>
          <div class="tile__label">
            <div class="tile__title">{{question?.question_prompt}}</div>
          </div>
        </div>
      </div>
      @if (showTextbox(question) || (i === 2 && question?.itk)) {
        <div class="tile__slot">
          @if (showTextbox(question)) {
            <div class="tile__slot-reveal">
              <div class="form-group">
                <input type="text" [value]="question?.answer" placeholder="" (blur)="setAnswer(question,$event)" class="form-control" />
              </div>
            </div>
          }
          @if (i === 2 && question?.itk) {
            <div class="itk">
              <div class="itk__items">
                <div class="itk__item">
                  <div class="itk__item-icon">
                    <img src="/assets/0/favicon/favicon-black.svg" class="icon icon--sm" />
                  </div>
                  <div class="itk__item-content" [innerHTML]="'<strong>Important to know</strong> ' + (question?.itk || '')"></div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </label>
}


</div>